import styled from '@emotion/styled';

const StyledBottom = styled.div(
  {
    'marginTop': 50,
    'display': 'flex',
    'color': 'rgba(255,255,255,0.83)',
    '& > div': {
      'marginLeft': 26,
      'display': 'flex',
      '& > h3': {
        marginLeft: 5
      }
    },
    '& h3': {
      marginBottom: 0
    }
  },
  ({ theme }) => ({
    fontSize: theme.typography.fontSize.medium
  })
);

export default StyledBottom;
